import TR from 'utils/TR';
import Honeycomb from 'components/common/Honeycomb';
import T from 'utils/T';
import ex from 'utils/ex';
import { numberWithComma } from 'utils/number';
import HBox from 'components/common/HBox';
import Segment from 'components/common/Segment';
import DIRECTION_VERTICAL from 'constants/DIRECTION_VERTICAL';
import SummaryBox from '../ReportBloodGlocose/SummaryBox';
import Dot from 'components/common/Dot';
import VBar from '../ReportBloodGlocose/VBar';

export default function DietSummary(props) {
  const {
    mealData,
    ...rest
  } = props;

  const {
    avg_intaken_cal = 0,
    avg_meal_cnt = 0,
    carbo_intaken_cal = 0,
    carbo_intaken_cal_rate = 0,
    protein_intaken_cal_rate = 0,
    fat_intaken_cal_rate = 0,
    complex_bld_sugr_cnt = 0,
    high_bld_sugr_cnt = 0,
    high_bld_sugr_food,
    low_bld_sugr_cnt = 0,
    max_intaken_cal = 0,
    min_intaken_cal = 0,
    postprandial_abnormal_rate = 0,
    std_intaken_cal = 0,
    total_meal_cnt = 0,
  } = mealData || {};

  return (
    <HBox {...ex('DietSummary', rest)}>
      <Segment
        {...ex('Summary', {
          direction: DIRECTION_VERTICAL,
        })}
      >
        <HBox {...ex('SummaryTitle')} between>
          <div>
            {T('일평균 식사')}
          </div>
        </HBox>
        <HBox {...ex('SummaryItems')} between>
          <SummaryBox
            {...{
              caption: T('기록'),
              value: numberWithComma(avg_meal_cnt),
              unit: '회',
            }}
          />
          <VBar />
          <SummaryBox
            {...{
              caption: T('섭취칼로리'),
              value: numberWithComma(avg_intaken_cal),
              unit: 'kcal',
            }}
          />
          <HBox>
            {/* <SummaryBox
              {...ex('Sub', {
                caption: T('표준편차'),
                value: numberWithComma(std_intaken_cal),
                unit: 'kcal',
              })}
            /> */}
            <SummaryBox
              {...ex('Sub', {
                caption: T('최대'),
                value: numberWithComma(max_intaken_cal),
                unit: 'kcal',
              })}
            />
            <SummaryBox
              {...ex('Sub', {
                caption: T('최소'),
                value: numberWithComma(min_intaken_cal),
                unit: 'kcal',
              })}
            />
          </HBox>
        </HBox>
      </Segment>

      <Segment
        {...ex('Summary', {
          direction: DIRECTION_VERTICAL,
        })}
      >
        <HBox {...ex('SummaryTitle')} between>
          <div>
            {T('일평균 탄단지')}
          </div>
        </HBox>
        <HBox {...ex('SummaryItems')} between>
          <SummaryBox
            {...{
              caption: T('탄수화물'),
              value: carbo_intaken_cal_rate,
              unit: 'g',
            }}
          />
          <VBar />
          <SummaryBox
            {...{
              caption: T('단백질'),
              value: protein_intaken_cal_rate,
              unit: 'g',
            }}
          />
          <VBar />
          <SummaryBox
            {...{
              caption: T('지방'),
              value: fat_intaken_cal_rate,
              unit: 'g',
            }}
          />
        </HBox>
      </Segment>


      <Segment
        {...ex('Summary', {
          direction: DIRECTION_VERTICAL,
        })}
      >
        <HBox {...ex('SummaryTitle')} between>
          <div>
            {T('대표음식')}
          </div>
        </HBox>
        <HBox {...ex('SummaryItems')} between>
          <SummaryBox
            {...{
              caption: T('이상혈당 발생음식'),
              value: (high_bld_sugr_food || '').split(','),
            }}
          />
        </HBox>
      </Segment>

    </HBox>
  );
}
